var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "notificationListView",
      staticClass: "notification-list-view",
      class: { popup: !_vm.groupByDate },
    },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        !Object.keys(_vm.groups).length
          ? _c(
              "div",
              { staticClass: "empty-notifications" },
              [
                _vm.minimized
                  ? [
                      _c(
                        "div",
                        { staticClass: "material-icons notification-shake" },
                        [_vm._v("notifications_active")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "empty-message" }, [
                        _vm._v(
                          _vm._s(_vm.$t("notification.noNotificationTitle1"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { ghost: true, small: true },
                          on: { click: _vm.redirectNotificationSettings },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("search.allNotificationSettings"))
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "material-icons notification-shake" },
                        [_vm._v("notifications_active")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "empty-message-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("notification.noNotificationTitle2"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "empty-message" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("notification.noNotificationDesc2")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { ghost: true, small: true },
                          on: { click: _vm.redirectNotificationSettings },
                        },
                        [_vm._v(_vm._s(_vm.$t("notification.adjustNow")))]
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "groups" },
          _vm._l(Object.keys(_vm.groups), function (date) {
            return _c("div", { key: date, staticClass: "group" }, [
              _vm.groupByDate
                ? _c("div", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(_vm.$moment(date, "YYYY-MM-DD").format("LL"))
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "items" },
                _vm._l(_vm.groups[date], function (notification) {
                  return _c("NotificationCard", {
                    key: notification._id,
                    attrs: {
                      notification: notification,
                      onCardClick: "{onCardClick}",
                    },
                    on: { markRead: _vm.markRead, markUnread: _vm.markUnread },
                  })
                }),
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }